import { competenciesSchema } from '../job-profile/job-profile-schema';

import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type { LoaderFunction } from 'react-router';

export const createPositionManagementPageLoader = (
    validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl,
): LoaderFunction => {
    return async () => {
        const competencies = await validatingCobrainerApiFetcher.get(competenciesSchema, {
            pathname: '/skills/competencies',
        });

        return {
            competencies,
        };
    };
};
